import { render, staticRenderFns } from "./EditPendingDialogFormContentWrapper.vue?vue&type=template&id=ccdb3ace&scoped=true&"
import script from "./EditPendingDialogFormContentWrapper.vue?vue&type=script&lang=js&"
export * from "./EditPendingDialogFormContentWrapper.vue?vue&type=script&lang=js&"
import style0 from "./EditPendingDialogFormContentWrapper.vue?vue&type=style&index=0&id=ccdb3ace&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccdb3ace",
  null
  
)

export default component.exports